import { AllAgenciesDto, UserDtoWithRoles } from '@zorro/clients';

const ZORRO_ENROLLMENT_TEAM_IDS =
  process.env.NEXT_PUBLIC_ZORRO_MANAGED_ENROLLMENT_TEAM_IDS;

export const getEmployerAgencyNames = (
  zorroPartnerId: string | null | undefined,
  producerId: string | null | undefined,
  enrollmentTeamIds: string[],
  allAgencies: AllAgenciesDto
): {
  myEnrollmentTeams: string[];
  myZorroPartner?: string;
  myProducer?: string;
} => {
  const myZorroPartner = allAgencies.zorroPartners.find(
    (zorroPartner) => zorroPartner.id === zorroPartnerId
  )?.name;
  const myProducer = [
    ...allAgencies.producers,
    ...allAgencies.zorroPartners,
  ].find((producer) => producer.id === producerId)?.name;
  const myEnrollmentTeams =
    enrollmentTeamIds.length > 0
      ? enrollmentTeamIds.flatMap(
          (agentId) =>
            [...allAgencies.enrollmentTeams, ...allAgencies.zorroPartners].find(
              (agent) => agent.id === agentId
            )?.name ?? []
        )
      : [];

  return {
    myEnrollmentTeams,
    myZorroPartner,
    myProducer,
  };
};

export const isZorroManagedEnrollmentTeam = (
  agencyId: string | null | undefined
): boolean => {
  if (!agencyId) {
    return false;
  }
  return (
    ZORRO_ENROLLMENT_TEAM_IDS?.split(',')
      ?.map((id) => id.trim())
      ?.includes(agencyId) ?? false
  );
};

export const isNonZorroEnrollmentAgent = (
  user: Pick<UserDtoWithRoles, 'email' | 'tenantId'> | null
): boolean => {
  if (!user) {
    return false;
  }
  const { email, tenantId } = user;
  const isInZorroEnrollmentAgency = isZorroManagedEnrollmentTeam(tenantId);
  const normalizedEmail = email?.trim().toLowerCase();
  const isNotZorroEnrollmentEmail =
    normalizedEmail === null || !normalizedEmail.endsWith('@myzorro.co');
  return isInZorroEnrollmentAgency && isNotZorroEnrollmentEmail;
};
